var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginFail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.6799C2.5 6.01524 2.5 4.68291 2.8146 4.23469C3.12919 3.78646 4.38194 3.35765 6.88743 2.50001L7.36477 2.33661C8.67082 1.88955 9.32384 1.66602 10 1.66602C10.6762 1.66602 11.3292 1.88955 12.6352 2.33661L13.1126 2.50001C15.6181 3.35765 16.8708 3.78646 17.1854 4.23469C17.5 4.68291 17.5 6.01524 17.5 8.6799C17.5 9.08239 17.5 9.51886 17.5 9.99215C17.5 14.6905 13.9675 16.9706 11.7512 17.9387C11.15 18.2014 10.8494 18.3327 10 18.3327C9.15062 18.3327 8.85001 18.2014 8.2488 17.9387C6.03247 16.9706 2.5 14.6905 2.5 9.99215C2.5 9.51886 2.5 9.08239 2.5 8.6799Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0837 7.91602L7.91701 12.0827M7.91699 7.916L12.0836 12.0826",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginFail);
export default __webpack_public_path__ + "static/media/LoginFail.53dbde5a74d8aa70904fddc545114079.svg";
export { ForwardRef as ReactComponent };